import imgT1 from "../assets/image/jpg/dev/regular/portfolio-1.jpg";
import imgT2 from "../assets/image/jpg/dev/regular/portfolio-2.jpg";
import imgT3 from "../assets/image/jpg/dev/regular/portfolio-3.jpg";
import imgT4 from "../assets/image/jpg/dev/regular/portfolio-4.jpg";
import imgT5 from "../assets/image/jpg/dev/regular/portfolio-5.jpg";
import imgT6 from "../assets/image/jpg/dev/regular/portfolio-6.jpg";
import imgT7 from "../assets/image/jpg/dev/regular/portfolio-7.jpg";
import imgT8 from "../assets/image/jpg/dev/regular/portfolio-8.jpg";

export const devWorks2 = [
  {
    brand: `Perfumed App`,
    slug: `perfumed-app`,
    title: `Adaptable but Identifiable Product for Kandinsky.`,
    categories: [`web`],
    thumbnail: imgT1,
  link : "/portfolio-details"
},
  {
    brand: `Travel App`,
    slug: `travel-app`,
    title: `Adaptable but Identifiable Product for Kandinsky.`,
    categories: [`app`, `web`],
    thumbnail: imgT2,
  link : "/portfolio-details"
},
  {
    brand: `Shopper`,
    slug: `shopper`,
    title: `Adaptable but Identifiable Product for Kandinsky.`,
    categories: [`web`, `ui-design`],
    thumbnail: imgT3,
  link : "/portfolio-details"
},
  {
    brand: `Candy Store`,
    slug: `candy-store`,
    title: `Adaptable but Identifiable Product for Kandinsky.`,
    categories: [`app`, `ui-design`, `web`],
    thumbnail: imgT4,
  link : "/portfolio-details"
},
  {
    brand: `Travel App`,
    slug: `travel-app`,
    title: `Adaptable but Identifiable Product for Kandinsky.`,
    categories: [`app`, `ui-design`],
    thumbnail: imgT5,
  link : "/portfolio-details"
},
  {
    brand: `App Ice Cream`,
    slug: `app-ice-cream`,
    title: `Adaptable but Identifiable Product for Kandinsky.`,
    categories: [`ui-design`, `web`],
    thumbnail: imgT6,
  link : "/portfolio-details"
},
  {
    brand: `Camera`,
    slug: `Camera`,
    title: `Adaptable but Identifiable Product for Kandinsky.`,
    categories: [`app`, `ui-design`],
    thumbnail: imgT7,
  link : "/portfolio-details"
},
  {
    brand: `Smart Watch`,
    slug: `smart-watch`,
    title: `Adaptable but Identifiable Product for Kandinsky.`,
    categories: [`web`, `ui-design`],
    thumbnail: imgT8,
  link : "/portfolio-details"
},
];
